export function isYouTubeVideo(url: string): boolean {
  return url.includes('youtube.com') || url.includes('youtu.be');
}

export function getYouTubeEmbedUrl(url: string, ): string {
  if (!url) {
    return '';
  }

  let videoId = '';
  if (url.includes('youtube.com')) {
    videoId = url.split('v=')[1]?.split('&')[0] || '';
  } else if (url.includes('youtu.be')) {
    videoId = url.split('/').pop()?.split('?')[0] || '';
  }

  if (!videoId) {
    return '';
  }

  return `https://www.youtube.com/embed/${videoId}`;
}
